export default 'icon--facebook';